import axios from '../../config/axios';
import apiPaths from '../apiPaths';

// get all file containers or just those matching the insuredRiskId
const onGetFileContainers = (insuredRiskId) =>
  axios.get(apiPaths.fileContainersBase, { params: { insured_risk_id: insuredRiskId } });

export { onGetFileContainers };
